/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { PropsWithChildren } from "react";
import sass from "./head.module.sass";
import { ReactComponent as BackArrow } from "images/back-arrow.svg";
import { useNavigate } from "react-router-dom";

interface IHeadPage extends PropsWithChildren {
	title: any;
	topTitle?: string;
	subTitle?: any;
	parentFuncForRedirect?: () => void;
}

/**
 * @description Компонент заголовка для страницы
 * @param {IHeadPage} props
 * @param {any} props.children - принимает потомков для отображения их в правой части заголовка
 * @param {string} props.topTitle - верхняя подпись страницы
 * @param {any} props.title - принимает что-угодно для отображения главного заголовка страницы
 * @param {any} props.subTitle - принимает что-угодно для отображения нижней подписи заголовка страницы
 * @constructor
 */
const HeadPage: React.FC<IHeadPage> = ({ children, parentFuncForRedirect, topTitle, title, subTitle }) => {
	const navigate = useNavigate();
	return (
		<div className={sass.wrapper}>
			<div>
				<div className={sass.left}>
					<div
						onClick={() => {
							navigate(-1);
							parentFuncForRedirect && parentFuncForRedirect();
						}}
						className={sass.redirect}>
						<BackArrow />
					</div>
					<div className={sass.title}>
						{topTitle && <p className={sass.mute}>{topTitle}</p>}
						<div className={sass.text}>{title}</div>
						{subTitle && <div className={sass.mute}>{subTitle}</div>}
					</div>
				</div>
				{children && children}
			</div>
		</div>
	);
};

export default HeadPage;
